import SpinLoading from '@/components/loading/SpinLoading';
import { useHistoryTrade } from '@/hooks/useGetHistory';
import Empty from './Empty';
import Item from './item';

export default function HistoryOrders() {
    const { data, isLoading } = useHistoryTrade();

    if (isLoading) {
        return (
            <div className="mx-auto flex justify-center mt-10">
                <SpinLoading />
            </div>
        );
    }

    if (data?.length === 0 && !isLoading) {
        return <Empty />;
    }

    return (
        <div className="p-4 flex flex-col gap-4">
            {data?.map((item, index) => (
                <Item key={index} item={item} />
            ))}
        </div>
    );
}
